import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ClientInformationModel } from 'src/Models/ClientInformationModel';
import { PricingQuotesService } from 'src/Services/pricing-quotes.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-onboarding-list',
  templateUrl: './onboarding-list.component.html',
  styleUrls: ['./onboarding-list.component.css']
})
export class OnboardingListComponent implements OnInit {

  stateCode: any;
  tokenKey: string;
  listofPricingQuotes: ClientInformationModel[];
  listofPricingQuotesExport: ClientInformationModel[];

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  CompanyName: string;
  isSubmit: boolean = false;

  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;
  clientInformationId: number = 0;
  Sent: string;
  DisplayQuote: string;
  isChecked: boolean = false;
  isCheckedDisplayQuote: boolean = false;
  blockedDocument: boolean;
  Sent1: string;
  duplicateClientInformationId: number = 0;

  priceQuoteId: number = 0;
  AdminId: number = 0;

  upDownCompanyNameCSS: string = '';
  upDownQuoteRequestedByCSS: string = '';
  upDownProposelDateCSS: string = '';
  upDownProposelModifiedDateCSS: string = '';
  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly PricingQuotesMaster: PricingQuotesService,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofPricingQuotes = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'CreatedDate desc';
    //this.upDownProposelDateCSS = 'fa fa-arrow-down'
    this.isAscending = true;
    this.CompanyName = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Onboarding');
    sessionStorage.removeItem('ClientCompanyName');
    sessionStorage.removeItem('AdminClientCompanyId');
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.GetOnboardingList();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetOnboardingList();
  }

  GetOnboardingList() {
    this.isloading = true;
    this.listofPricingQuotes = [];
    this.PricingQuotesMaster.GetOnboardingList(this.tokenKey, this.PageNumber, this.PageSize, this.CompanyName, this.OrderBy,false).subscribe(
      data => {
        this.isloading = false;
        this.listofPricingQuotes = data['pricingQuotes'];
        if (this.listofPricingQuotes != null) {
          if (this.listofPricingQuotes.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofPricingQuotes[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { this.stateCode = error }
    );
  }

  sort(sortBy: string) {
    this.upDownCompanyNameCSS = '';
    this.upDownQuoteRequestedByCSS = '';
    this.upDownProposelDateCSS = '';
    this.upDownProposelModifiedDateCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "CompanyName") {
        this.upDownCompanyNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedByName") {
        this.upDownQuoteRequestedByCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedDate") {
        this.upDownProposelDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "UpdatedDate") {
        this.upDownProposelModifiedDateCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "CompanyName") {
        this.upDownCompanyNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedByName") {
        this.upDownQuoteRequestedByCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedDate") {
        this.upDownProposelDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "UpdatedDate") {
        this.upDownProposelModifiedDateCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetOnboardingList();
  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.CompanyName = $event.target.value;
    else
      this.CompanyName = 'null';

    this.GetOnboardingList();
  }
  updatePricingQuotes(clientInformationId, companyName, companyId) {
    localStorage.setItem('UserLoginTool', 'PricingQuote');
    sessionStorage.setItem('ClientCompanyName', companyName);
    let navigation = '/admin/PricingQuote/add-company-info/' + clientInformationId + '/' + companyId;
    this.router.navigate([navigation]);
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportOnboarding() {
    this.isloading = true;
    this.listofPricingQuotesExport = [];
    this.PricingQuotesMaster.GetOnboardingList(this.tokenKey, this.PageNumber, this.PageSize, this.CompanyName, this.OrderBy,true).subscribe(
      data => {
        this.listofPricingQuotesExport = data['pricingQuotes'];
        if (this.listofPricingQuotesExport != null) {
          if (this.listofPricingQuotesExport.length > 0) {
            setTimeout(() => {
              this.DownloadPriceQuoteOnboarding();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadPriceQuoteOnboarding() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportPriceQuoteOnboarding';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportPriceQuoteOnboarding.xls");
  }

}
